import api from '../base'

export default {
  getLanguage: () => {
    return api.get(process.env.VUE_APP_LANGUAGE_FILE)
  },
}
